export default __webpack_public_path__ + "static/media/trophy.e1345226.svg";